import ajax from "../utils/request.js";

//菜单列表 get /api/rule/lists
const rulelists = (data) => {
  return ajax.get("/api/rule/lists", data);
};
//上级菜单 get /rule/parents
const ruleparents = (data) => {
  return ajax.get("/api/rule/parents", data);
};
//添加菜单 get /rule/add
const ruleAdd = (data) => {
  return ajax.post("/api/rule/add", data);
};
//编辑菜单 get /rule/edit
const ruleEdit = (data) => {
  return ajax.post("/api/rule/edit", data);
};


export {
  rulelists,
  ruleparents,
  ruleAdd,
  ruleEdit
}